export default __webpack_public_path__ + "static/hooked-on-you-f8521ffacedc2eb8e617ab5c2ad64b2e.jpg";